export default "__VITE_ASSET__f72642b2__"